import { render } from "./GlobalNotification.vue?vue&type=template&id=1aa435ab&scoped=true"
import script from "./GlobalNotification.vue?vue&type=script&lang=js"
export * from "./GlobalNotification.vue?vue&type=script&lang=js"

import "./GlobalNotification.vue?vue&type=style&index=0&id=1aa435ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa435ab"]])

export default __exports__